import { type SerializeFrom } from '@cx-web/domain-types';
import { type DehydratedState } from '@tanstack/react-query';

export function invalidDehydratedState(
  dehydratedState: DehydratedState | null | undefined | SerializeFrom<DehydratedState | null>,
): dehydratedState is DehydratedState {
  return (
    (dehydratedState &&
      (dehydratedState.queries.length === 0 || dehydratedState.queries.every(query => query.state.data === null))) ||
    false
  );
}
